// proto/v2/document/document.proto

// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file document/document.proto (package lvdr.v2.document, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { PaginationParams, ProgressInfo } from "../common/common_pb";
import { file_common_common } from "../common/common_pb";
import type { Sensitivity } from "../common/sensitivity_pb";
import { file_common_sensitivity } from "../common/sensitivity_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file document/document.proto.
 */
export const file_document_document: GenFile = /*@__PURE__*/
  fileDesc("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", [file_google_protobuf_timestamp, file_common_common, file_common_sensitivity]);

/**
 * Requests
 *
 * @generated from message lvdr.v2.document.UploadDocumentRequest
 */
export type UploadDocumentRequest = Message<"lvdr.v2.document.UploadDocumentRequest"> & {
  /**
   * @generated from field: string research_id = 1;
   */
  researchId: string;

  /**
   * @generated from field: string filename = 2;
   */
  filename: string;

  /**
   * @generated from field: string content_type = 3;
   */
  contentType: string;

  /**
   * @generated from field: bytes content = 4;
   */
  content: Uint8Array;
};

/**
 * Describes the message lvdr.v2.document.UploadDocumentRequest.
 * Use `create(UploadDocumentRequestSchema)` to create a new message.
 */
export const UploadDocumentRequestSchema: GenMessage<UploadDocumentRequest> = /*@__PURE__*/
  messageDesc(file_document_document, 0);

/**
 * @generated from message lvdr.v2.document.DeleteDocumentRequest
 */
export type DeleteDocumentRequest = Message<"lvdr.v2.document.DeleteDocumentRequest"> & {
  /**
   * research_id field 2 removed — not needed for per-user delete
   *
   * @generated from field: string document_id = 1;
   */
  documentId: string;
};

/**
 * Describes the message lvdr.v2.document.DeleteDocumentRequest.
 * Use `create(DeleteDocumentRequestSchema)` to create a new message.
 */
export const DeleteDocumentRequestSchema: GenMessage<DeleteDocumentRequest> = /*@__PURE__*/
  messageDesc(file_document_document, 1);

/**
 * @generated from message lvdr.v2.document.GetDocumentRequest
 */
export type GetDocumentRequest = Message<"lvdr.v2.document.GetDocumentRequest"> & {
  /**
   * @generated from field: string document_id = 1;
   */
  documentId: string;
};

/**
 * Describes the message lvdr.v2.document.GetDocumentRequest.
 * Use `create(GetDocumentRequestSchema)` to create a new message.
 */
export const GetDocumentRequestSchema: GenMessage<GetDocumentRequest> = /*@__PURE__*/
  messageDesc(file_document_document, 2);

/**
 * @generated from message lvdr.v2.document.ListDocumentsRequest
 */
export type ListDocumentsRequest = Message<"lvdr.v2.document.ListDocumentsRequest"> & {
  /**
   * optional: filter by collection (replaces research_id)
   *
   * @generated from field: string collection_id = 1;
   */
  collectionId: string;

  /**
   * @generated from field: lvdr.v2.common.PaginationParams pagination = 2;
   */
  pagination?: PaginationParams | undefined;
};

/**
 * Describes the message lvdr.v2.document.ListDocumentsRequest.
 * Use `create(ListDocumentsRequestSchema)` to create a new message.
 */
export const ListDocumentsRequestSchema: GenMessage<ListDocumentsRequest> = /*@__PURE__*/
  messageDesc(file_document_document, 3);

/**
 * @generated from message lvdr.v2.document.UpdateDocumentMetadataRequest
 */
export type UpdateDocumentMetadataRequest = Message<"lvdr.v2.document.UpdateDocumentMetadataRequest"> & {
  /**
   * @generated from field: string document_id = 1;
   */
  documentId: string;

  /**
   * @generated from field: string title = 2;
   */
  title: string;

  /**
   * @generated from field: map<string, string> metadata = 3;
   */
  metadata: { [key: string]: string };

  /**
   * @generated from field: optional bool pinned = 4;
   */
  pinned?: boolean | undefined;

  /**
   * @generated from field: optional lvdr.v2.common.Sensitivity sensitivity = 5;
   */
  sensitivity?: Sensitivity | undefined;
};

/**
 * Describes the message lvdr.v2.document.UpdateDocumentMetadataRequest.
 * Use `create(UpdateDocumentMetadataRequestSchema)` to create a new message.
 */
export const UpdateDocumentMetadataRequestSchema: GenMessage<UpdateDocumentMetadataRequest> = /*@__PURE__*/
  messageDesc(file_document_document, 4);

/**
 * @generated from message lvdr.v2.document.SearchDocumentsRequest
 */
export type SearchDocumentsRequest = Message<"lvdr.v2.document.SearchDocumentsRequest"> & {
  /**
   * was research_id — optional filter by collection
   *
   * @generated from field: string collection_id = 1;
   */
  collectionId: string;

  /**
   * @generated from field: string query = 2;
   */
  query: string;

  /**
   * @generated from field: int32 limit = 3;
   */
  limit: number;
};

/**
 * Describes the message lvdr.v2.document.SearchDocumentsRequest.
 * Use `create(SearchDocumentsRequestSchema)` to create a new message.
 */
export const SearchDocumentsRequestSchema: GenMessage<SearchDocumentsRequest> = /*@__PURE__*/
  messageDesc(file_document_document, 5);

/**
 * @generated from message lvdr.v2.document.GetDocumentContentRequest
 */
export type GetDocumentContentRequest = Message<"lvdr.v2.document.GetDocumentContentRequest"> & {
  /**
   * @generated from field: string document_id = 1;
   */
  documentId: string;
};

/**
 * Describes the message lvdr.v2.document.GetDocumentContentRequest.
 * Use `create(GetDocumentContentRequestSchema)` to create a new message.
 */
export const GetDocumentContentRequestSchema: GenMessage<GetDocumentContentRequest> = /*@__PURE__*/
  messageDesc(file_document_document, 6);

/**
 * @generated from message lvdr.v2.document.SubscribeDocumentIndexingRequest
 */
export type SubscribeDocumentIndexingRequest = Message<"lvdr.v2.document.SubscribeDocumentIndexingRequest"> & {
  /**
   * @generated from field: string research_id = 1;
   */
  researchId: string;
};

/**
 * Describes the message lvdr.v2.document.SubscribeDocumentIndexingRequest.
 * Use `create(SubscribeDocumentIndexingRequestSchema)` to create a new message.
 */
export const SubscribeDocumentIndexingRequestSchema: GenMessage<SubscribeDocumentIndexingRequest> = /*@__PURE__*/
  messageDesc(file_document_document, 7);

/**
 * @generated from message lvdr.v2.document.UnsubscribeDocumentIndexingRequest
 */
export type UnsubscribeDocumentIndexingRequest = Message<"lvdr.v2.document.UnsubscribeDocumentIndexingRequest"> & {
  /**
   * @generated from field: string research_id = 1;
   */
  researchId: string;
};

/**
 * Describes the message lvdr.v2.document.UnsubscribeDocumentIndexingRequest.
 * Use `create(UnsubscribeDocumentIndexingRequestSchema)` to create a new message.
 */
export const UnsubscribeDocumentIndexingRequestSchema: GenMessage<UnsubscribeDocumentIndexingRequest> = /*@__PURE__*/
  messageDesc(file_document_document, 8);

/**
 * @generated from message lvdr.v2.document.BuildIndexRequest
 */
export type BuildIndexRequest = Message<"lvdr.v2.document.BuildIndexRequest"> & {
  /**
   * @generated from field: string research_id = 1;
   */
  researchId: string;

  /**
   * @generated from field: bool force_rebuild = 2;
   */
  forceRebuild: boolean;
};

/**
 * Describes the message lvdr.v2.document.BuildIndexRequest.
 * Use `create(BuildIndexRequestSchema)` to create a new message.
 */
export const BuildIndexRequestSchema: GenMessage<BuildIndexRequest> = /*@__PURE__*/
  messageDesc(file_document_document, 9);

/**
 * @generated from message lvdr.v2.document.UpdateIndexRequest
 */
export type UpdateIndexRequest = Message<"lvdr.v2.document.UpdateIndexRequest"> & {
  /**
   * @generated from field: string research_id = 1;
   */
  researchId: string;

  /**
   * @generated from field: repeated string document_ids = 2;
   */
  documentIds: string[];
};

/**
 * Describes the message lvdr.v2.document.UpdateIndexRequest.
 * Use `create(UpdateIndexRequestSchema)` to create a new message.
 */
export const UpdateIndexRequestSchema: GenMessage<UpdateIndexRequest> = /*@__PURE__*/
  messageDesc(file_document_document, 10);

/**
 * @generated from message lvdr.v2.document.GetIndexInfoRequest
 */
export type GetIndexInfoRequest = Message<"lvdr.v2.document.GetIndexInfoRequest"> & {
  /**
   * @generated from field: string research_id = 1;
   */
  researchId: string;
};

/**
 * Describes the message lvdr.v2.document.GetIndexInfoRequest.
 * Use `create(GetIndexInfoRequestSchema)` to create a new message.
 */
export const GetIndexInfoRequestSchema: GenMessage<GetIndexInfoRequest> = /*@__PURE__*/
  messageDesc(file_document_document, 11);

/**
 * Responses
 *
 * @generated from message lvdr.v2.document.DocumentResponse
 */
export type DocumentResponse = Message<"lvdr.v2.document.DocumentResponse"> & {
  /**
   * @generated from field: lvdr.v2.document.Document document = 1;
   */
  document?: Document | undefined;
};

/**
 * Describes the message lvdr.v2.document.DocumentResponse.
 * Use `create(DocumentResponseSchema)` to create a new message.
 */
export const DocumentResponseSchema: GenMessage<DocumentResponse> = /*@__PURE__*/
  messageDesc(file_document_document, 12);

/**
 * @generated from message lvdr.v2.document.DocumentListResponse
 */
export type DocumentListResponse = Message<"lvdr.v2.document.DocumentListResponse"> & {
  /**
   * @generated from field: repeated lvdr.v2.document.Document documents = 1;
   */
  documents: Document[];

  /**
   * @generated from field: int32 total = 2;
   */
  total: number;
};

/**
 * Describes the message lvdr.v2.document.DocumentListResponse.
 * Use `create(DocumentListResponseSchema)` to create a new message.
 */
export const DocumentListResponseSchema: GenMessage<DocumentListResponse> = /*@__PURE__*/
  messageDesc(file_document_document, 13);

/**
 * @generated from message lvdr.v2.document.SearchResultsResponse
 */
export type SearchResultsResponse = Message<"lvdr.v2.document.SearchResultsResponse"> & {
  /**
   * @generated from field: repeated lvdr.v2.document.SearchResult results = 1;
   */
  results: SearchResult[];

  /**
   * @generated from field: string query = 2;
   */
  query: string;
};

/**
 * Describes the message lvdr.v2.document.SearchResultsResponse.
 * Use `create(SearchResultsResponseSchema)` to create a new message.
 */
export const SearchResultsResponseSchema: GenMessage<SearchResultsResponse> = /*@__PURE__*/
  messageDesc(file_document_document, 14);

/**
 * @generated from message lvdr.v2.document.DocumentContentResponse
 */
export type DocumentContentResponse = Message<"lvdr.v2.document.DocumentContentResponse"> & {
  /**
   * @generated from field: string document_id = 1;
   */
  documentId: string;

  /**
   * @generated from field: bytes content = 2;
   */
  content: Uint8Array;

  /**
   * @generated from field: string content_type = 3;
   */
  contentType: string;

  /**
   * markdown is the converted text representation of a binary source document
   * (PDF/DOCX/…): the extractive/Docling output persisted at index time. Empty
   * for text-native docs (content already IS the text) and for rendered
   * artifacts (no text representation). The viewer prefers it for preview while
   * keeping `content` for the original-file download.
   *
   * @generated from field: string markdown = 4;
   */
  markdown: string;
};

/**
 * Describes the message lvdr.v2.document.DocumentContentResponse.
 * Use `create(DocumentContentResponseSchema)` to create a new message.
 */
export const DocumentContentResponseSchema: GenMessage<DocumentContentResponse> = /*@__PURE__*/
  messageDesc(file_document_document, 15);

/**
 * @generated from message lvdr.v2.document.BuildIndexResponse
 */
export type BuildIndexResponse = Message<"lvdr.v2.document.BuildIndexResponse"> & {
  /**
   * @generated from field: string research_id = 1;
   */
  researchId: string;

  /**
   * @generated from field: string status = 2;
   */
  status: string;
};

/**
 * Describes the message lvdr.v2.document.BuildIndexResponse.
 * Use `create(BuildIndexResponseSchema)` to create a new message.
 */
export const BuildIndexResponseSchema: GenMessage<BuildIndexResponse> = /*@__PURE__*/
  messageDesc(file_document_document, 16);

/**
 * @generated from message lvdr.v2.document.UpdateIndexResponse
 */
export type UpdateIndexResponse = Message<"lvdr.v2.document.UpdateIndexResponse"> & {
  /**
   * @generated from field: string research_id = 1;
   */
  researchId: string;

  /**
   * @generated from field: int32 documents_updated = 2;
   */
  documentsUpdated: number;
};

/**
 * Describes the message lvdr.v2.document.UpdateIndexResponse.
 * Use `create(UpdateIndexResponseSchema)` to create a new message.
 */
export const UpdateIndexResponseSchema: GenMessage<UpdateIndexResponse> = /*@__PURE__*/
  messageDesc(file_document_document, 17);

/**
 * @generated from message lvdr.v2.document.IndexInfoResponse
 */
export type IndexInfoResponse = Message<"lvdr.v2.document.IndexInfoResponse"> & {
  /**
   * @generated from field: string research_id = 1;
   */
  researchId: string;

  /**
   * @generated from field: int32 total_documents = 2;
   */
  totalDocuments: number;

  /**
   * @generated from field: int32 indexed_documents = 3;
   */
  indexedDocuments: number;

  /**
   * @generated from field: string status = 4;
   */
  status: string;

  /**
   * @generated from field: google.protobuf.Timestamp last_built_at = 5;
   */
  lastBuiltAt?: Timestamp | undefined;
};

/**
 * Describes the message lvdr.v2.document.IndexInfoResponse.
 * Use `create(IndexInfoResponseSchema)` to create a new message.
 */
export const IndexInfoResponseSchema: GenMessage<IndexInfoResponse> = /*@__PURE__*/
  messageDesc(file_document_document, 18);

/**
 * Events
 *
 * @generated from message lvdr.v2.document.DocumentIndexingProgressEvent
 */
export type DocumentIndexingProgressEvent = Message<"lvdr.v2.document.DocumentIndexingProgressEvent"> & {
  /**
   * @generated from field: string research_id = 1;
   */
  researchId: string;

  /**
   * @generated from field: lvdr.v2.common.ProgressInfo progress = 2;
   */
  progress?: ProgressInfo | undefined;

  /**
   * document_id targets a per-user library document (the high-effort Docling
   * conversion progress). progress.completed / progress.total carry page X / N;
   * progress.current_phase is the conversion phase (e.g. "converting").
   *
   * @generated from field: string document_id = 3;
   */
  documentId: string;
};

/**
 * Describes the message lvdr.v2.document.DocumentIndexingProgressEvent.
 * Use `create(DocumentIndexingProgressEventSchema)` to create a new message.
 */
export const DocumentIndexingProgressEventSchema: GenMessage<DocumentIndexingProgressEvent> = /*@__PURE__*/
  messageDesc(file_document_document, 19);

/**
 * @generated from message lvdr.v2.document.DocumentIndexingCompletedEvent
 */
export type DocumentIndexingCompletedEvent = Message<"lvdr.v2.document.DocumentIndexingCompletedEvent"> & {
  /**
   * @generated from field: string research_id = 1;
   */
  researchId: string;

  /**
   * @generated from field: int32 documents_indexed = 2;
   */
  documentsIndexed: number;

  /**
   * @generated from field: google.protobuf.Timestamp completed_at = 3;
   */
  completedAt?: Timestamp | undefined;
};

/**
 * Describes the message lvdr.v2.document.DocumentIndexingCompletedEvent.
 * Use `create(DocumentIndexingCompletedEventSchema)` to create a new message.
 */
export const DocumentIndexingCompletedEventSchema: GenMessage<DocumentIndexingCompletedEvent> = /*@__PURE__*/
  messageDesc(file_document_document, 20);

/**
 * @generated from message lvdr.v2.document.DocumentListChangedEvent
 */
export type DocumentListChangedEvent = Message<"lvdr.v2.document.DocumentListChangedEvent"> & {
  /**
   * @generated from field: string research_id = 1;
   */
  researchId: string;

  /**
   * @generated from field: string change_type = 2;
   */
  changeType: string;

  /**
   * @generated from field: string document_id = 3;
   */
  documentId: string;
};

/**
 * Describes the message lvdr.v2.document.DocumentListChangedEvent.
 * Use `create(DocumentListChangedEventSchema)` to create a new message.
 */
export const DocumentListChangedEventSchema: GenMessage<DocumentListChangedEvent> = /*@__PURE__*/
  messageDesc(file_document_document, 21);

/**
 * @generated from message lvdr.v2.document.IndexStatusChangedEvent
 */
export type IndexStatusChangedEvent = Message<"lvdr.v2.document.IndexStatusChangedEvent"> & {
  /**
   * @generated from field: string research_id = 1;
   */
  researchId: string;

  /**
   * @generated from field: string status = 2;
   */
  status: string;

  /**
   * @generated from field: string previous_status = 3;
   */
  previousStatus: string;
};

/**
 * Describes the message lvdr.v2.document.IndexStatusChangedEvent.
 * Use `create(IndexStatusChangedEventSchema)` to create a new message.
 */
export const IndexStatusChangedEventSchema: GenMessage<IndexStatusChangedEvent> = /*@__PURE__*/
  messageDesc(file_document_document, 22);

/**
 * Domain models
 *
 * @generated from message lvdr.v2.document.Document
 */
export type Document = Message<"lvdr.v2.document.Document"> & {
  /**
   * @generated from field: string document_id = 1;
   */
  documentId: string;

  /**
   * was research_id — now user who owns the doc
   *
   * @generated from field: string owner_id = 2;
   */
  ownerId: string;

  /**
   * which collection it belongs to
   *
   * @generated from field: string collection_id = 3;
   */
  collectionId: string;

  /**
   * @generated from field: string title = 4;
   */
  title: string;

  /**
   * @generated from field: string filename = 5;
   */
  filename: string;

  /**
   * @generated from field: string content_type = 6;
   */
  contentType: string;

  /**
   * @generated from field: int64 size_bytes = 7;
   */
  sizeBytes: bigint;

  /**
   * @generated from field: string indexing_status = 8;
   */
  indexingStatus: string;

  /**
   * @generated from field: map<string, string> metadata = 9;
   */
  metadata: { [key: string]: string };

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 10;
   */
  createdAt?: Timestamp | undefined;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 11;
   */
  updatedAt?: Timestamp | undefined;

  /**
   * @generated from field: bool pinned = 12;
   */
  pinned: boolean;

  /**
   * @generated from field: repeated string tags = 13;
   */
  tags: string[];

  /**
   * @generated from field: string failure_reason = 14;
   */
  failureReason: string;

  /**
   * Docling Premium audit fields (added 2026-05-18).
   * converter_choice: what the user (or default) opted for at upload time
   *   ("", "markitdown", "docling"). Empty == policy default.
   * converter_used:   which converter actually ran, after fallback
   *   ("markitdown", "docling", or "docling→markitdown").
   * page_count:       sniffed page count of the source document (PDFs only).
   * docling_pages_used: pages the docling sidecar actually processed
   *   (may differ from page_count when LVDR_DOCLING_MAX_PAGES_GLOBAL clamps).
   *
   * @generated from field: string converter_choice = 15;
   */
  converterChoice: string;

  /**
   * @generated from field: string converter_used = 16;
   */
  converterUsed: string;

  /**
   * @generated from field: int32 page_count = 17;
   */
  pageCount: number;

  /**
   * @generated from field: int32 docling_pages_used = 18;
   */
  doclingPagesUsed: number;

  /**
   * Sensitivity gates outbound LLM/voice traffic. See common/sensitivity.proto.
   *
   * @generated from field: lvdr.v2.common.Sensitivity sensitivity = 19;
   */
  sensitivity: Sensitivity;

  /**
   * docling_vlm_mode: per-document escalation-lane override for the Docling
   *   premium path ("" | "verify" | "full" | "ocr"). Empty == use the user's
   *   docling.vlm_mode setting. Clamped to the tier's DoclingVLMLevel and the
   *   cloud egress guard server-side (never escalates past tier / leaks SECRET
   *   docs to the external OCR lane). Set via SetConverterChoiceRequest.
   *
   * @generated from field: string docling_vlm_mode = 20;
   */
  doclingVlmMode: string;

  /**
   * docling_fallback_category: why the premium (docling) conversion fell back to
   *   markitdown — one of "content" | "infra" | "timeout" | "unknown"; "" when the
   *   last conversion did not fall back (or predates BE-12). Never the raw error.
   *
   * @generated from field: string docling_fallback_category = 21;
   */
  doclingFallbackCategory: string;

  /**
   * docling_retry_expires_at: when the free-retry token written on that fallback
   *   expires. Unset when no token was written. The FE offers "Retry (free)" only
   *   while this is in the future.
   *
   * @generated from field: google.protobuf.Timestamp docling_retry_expires_at = 22;
   */
  doclingRetryExpiresAt?: Timestamp | undefined;
};

/**
 * Describes the message lvdr.v2.document.Document.
 * Use `create(DocumentSchema)` to create a new message.
 */
export const DocumentSchema: GenMessage<Document> = /*@__PURE__*/
  messageDesc(file_document_document, 23);

/**
 * @generated from message lvdr.v2.document.SearchResult
 */
export type SearchResult = Message<"lvdr.v2.document.SearchResult"> & {
  /**
   * @generated from field: string document_id = 1;
   */
  documentId: string;

  /**
   * @generated from field: string title = 2;
   */
  title: string;

  /**
   * @generated from field: string excerpt = 3;
   */
  excerpt: string;

  /**
   * @generated from field: double relevance_score = 4;
   */
  relevanceScore: number;
};

/**
 * Describes the message lvdr.v2.document.SearchResult.
 * Use `create(SearchResultSchema)` to create a new message.
 */
export const SearchResultSchema: GenMessage<SearchResult> = /*@__PURE__*/
  messageDesc(file_document_document, 24);

/**
 * Collection groups documents for user organization.
 *
 * @generated from message lvdr.v2.document.Collection
 */
export type Collection = Message<"lvdr.v2.document.Collection"> & {
  /**
   * @generated from field: string collection_id = 1;
   */
  collectionId: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string description = 3;
   */
  description: string;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 4;
   */
  createdAt?: Timestamp | undefined;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 5;
   */
  updatedAt?: Timestamp | undefined;
};

/**
 * Describes the message lvdr.v2.document.Collection.
 * Use `create(CollectionSchema)` to create a new message.
 */
export const CollectionSchema: GenMessage<Collection> = /*@__PURE__*/
  messageDesc(file_document_document, 25);

/**
 * Collection CRUD requests/responses
 *
 * @generated from message lvdr.v2.document.CreateCollectionRequest
 */
export type CreateCollectionRequest = Message<"lvdr.v2.document.CreateCollectionRequest"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * @generated from field: string description = 2;
   */
  description: string;
};

/**
 * Describes the message lvdr.v2.document.CreateCollectionRequest.
 * Use `create(CreateCollectionRequestSchema)` to create a new message.
 */
export const CreateCollectionRequestSchema: GenMessage<CreateCollectionRequest> = /*@__PURE__*/
  messageDesc(file_document_document, 26);

/**
 * @generated from message lvdr.v2.document.UpdateCollectionRequest
 */
export type UpdateCollectionRequest = Message<"lvdr.v2.document.UpdateCollectionRequest"> & {
  /**
   * @generated from field: string collection_id = 1;
   */
  collectionId: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string description = 3;
   */
  description: string;
};

/**
 * Describes the message lvdr.v2.document.UpdateCollectionRequest.
 * Use `create(UpdateCollectionRequestSchema)` to create a new message.
 */
export const UpdateCollectionRequestSchema: GenMessage<UpdateCollectionRequest> = /*@__PURE__*/
  messageDesc(file_document_document, 27);

/**
 * @generated from message lvdr.v2.document.DeleteCollectionRequest
 */
export type DeleteCollectionRequest = Message<"lvdr.v2.document.DeleteCollectionRequest"> & {
  /**
   * @generated from field: string collection_id = 1;
   */
  collectionId: string;
};

/**
 * Describes the message lvdr.v2.document.DeleteCollectionRequest.
 * Use `create(DeleteCollectionRequestSchema)` to create a new message.
 */
export const DeleteCollectionRequestSchema: GenMessage<DeleteCollectionRequest> = /*@__PURE__*/
  messageDesc(file_document_document, 28);

/**
 * @generated from message lvdr.v2.document.ListCollectionsRequest
 */
export type ListCollectionsRequest = Message<"lvdr.v2.document.ListCollectionsRequest"> & {
};

/**
 * Describes the message lvdr.v2.document.ListCollectionsRequest.
 * Use `create(ListCollectionsRequestSchema)` to create a new message.
 */
export const ListCollectionsRequestSchema: GenMessage<ListCollectionsRequest> = /*@__PURE__*/
  messageDesc(file_document_document, 29);

/**
 * @generated from message lvdr.v2.document.CollectionListResponse
 */
export type CollectionListResponse = Message<"lvdr.v2.document.CollectionListResponse"> & {
  /**
   * @generated from field: repeated lvdr.v2.document.Collection collections = 1;
   */
  collections: Collection[];
};

/**
 * Describes the message lvdr.v2.document.CollectionListResponse.
 * Use `create(CollectionListResponseSchema)` to create a new message.
 */
export const CollectionListResponseSchema: GenMessage<CollectionListResponse> = /*@__PURE__*/
  messageDesc(file_document_document, 30);

/**
 * @generated from message lvdr.v2.document.CollectionResponse
 */
export type CollectionResponse = Message<"lvdr.v2.document.CollectionResponse"> & {
  /**
   * @generated from field: lvdr.v2.document.Collection collection = 1;
   */
  collection?: Collection | undefined;
};

/**
 * Describes the message lvdr.v2.document.CollectionResponse.
 * Use `create(CollectionResponseSchema)` to create a new message.
 */
export const CollectionResponseSchema: GenMessage<CollectionResponse> = /*@__PURE__*/
  messageDesc(file_document_document, 31);

/**
 * Research-document linking
 *
 * @generated from message lvdr.v2.document.LinkDocumentRequest
 */
export type LinkDocumentRequest = Message<"lvdr.v2.document.LinkDocumentRequest"> & {
  /**
   * @generated from field: string research_id = 1;
   */
  researchId: string;

  /**
   * @generated from field: string document_id = 2;
   */
  documentId: string;
};

/**
 * Describes the message lvdr.v2.document.LinkDocumentRequest.
 * Use `create(LinkDocumentRequestSchema)` to create a new message.
 */
export const LinkDocumentRequestSchema: GenMessage<LinkDocumentRequest> = /*@__PURE__*/
  messageDesc(file_document_document, 32);

/**
 * @generated from message lvdr.v2.document.UnlinkDocumentRequest
 */
export type UnlinkDocumentRequest = Message<"lvdr.v2.document.UnlinkDocumentRequest"> & {
  /**
   * @generated from field: string research_id = 1;
   */
  researchId: string;

  /**
   * @generated from field: string document_id = 2;
   */
  documentId: string;
};

/**
 * Describes the message lvdr.v2.document.UnlinkDocumentRequest.
 * Use `create(UnlinkDocumentRequestSchema)` to create a new message.
 */
export const UnlinkDocumentRequestSchema: GenMessage<UnlinkDocumentRequest> = /*@__PURE__*/
  messageDesc(file_document_document, 33);

/**
 * @generated from message lvdr.v2.document.ListResearchDocumentsRequest
 */
export type ListResearchDocumentsRequest = Message<"lvdr.v2.document.ListResearchDocumentsRequest"> & {
  /**
   * @generated from field: string research_id = 1;
   */
  researchId: string;
};

/**
 * Describes the message lvdr.v2.document.ListResearchDocumentsRequest.
 * Use `create(ListResearchDocumentsRequestSchema)` to create a new message.
 */
export const ListResearchDocumentsRequestSchema: GenMessage<ListResearchDocumentsRequest> = /*@__PURE__*/
  messageDesc(file_document_document, 34);

/**
 * @generated from message lvdr.v2.document.Scope
 */
export type Scope = Message<"lvdr.v2.document.Scope"> & {
  /**
   * @generated from field: string scope_id = 1;
   */
  scopeId: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string description = 3;
   */
  description: string;

  /**
   * @generated from field: repeated string tags = 4;
   */
  tags: string[];

  /**
   * @generated from field: string parent_id = 5;
   */
  parentId: string;

  /**
   * @generated from field: string color = 6;
   */
  color: string;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 7;
   */
  createdAt?: Timestamp | undefined;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 8;
   */
  updatedAt?: Timestamp | undefined;

  /**
   * MEM-09d: the Context node this scope was converted into; "" = never converted. The
   * server's idempotency check reads it (a live, non-archived node ⇒ 409).
   *
   * @generated from field: string context_node_id = 9;
   */
  contextNodeId: string;
};

/**
 * Describes the message lvdr.v2.document.Scope.
 * Use `create(ScopeSchema)` to create a new message.
 */
export const ScopeSchema: GenMessage<Scope> = /*@__PURE__*/
  messageDesc(file_document_document, 35);

/**
 * @generated from message lvdr.v2.document.CreateScopeRequest
 */
export type CreateScopeRequest = Message<"lvdr.v2.document.CreateScopeRequest"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * @generated from field: string description = 2;
   */
  description: string;

  /**
   * @generated from field: repeated string tags = 3;
   */
  tags: string[];

  /**
   * @generated from field: string parent_id = 4;
   */
  parentId: string;

  /**
   * @generated from field: string color = 5;
   */
  color: string;
};

/**
 * Describes the message lvdr.v2.document.CreateScopeRequest.
 * Use `create(CreateScopeRequestSchema)` to create a new message.
 */
export const CreateScopeRequestSchema: GenMessage<CreateScopeRequest> = /*@__PURE__*/
  messageDesc(file_document_document, 36);

/**
 * @generated from message lvdr.v2.document.UpdateScopeRequest
 */
export type UpdateScopeRequest = Message<"lvdr.v2.document.UpdateScopeRequest"> & {
  /**
   * @generated from field: string scope_id = 1;
   */
  scopeId: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string description = 3;
   */
  description: string;

  /**
   * @generated from field: repeated string tags = 4;
   */
  tags: string[];

  /**
   * @generated from field: string parent_id = 5;
   */
  parentId: string;

  /**
   * @generated from field: string color = 6;
   */
  color: string;
};

/**
 * Describes the message lvdr.v2.document.UpdateScopeRequest.
 * Use `create(UpdateScopeRequestSchema)` to create a new message.
 */
export const UpdateScopeRequestSchema: GenMessage<UpdateScopeRequest> = /*@__PURE__*/
  messageDesc(file_document_document, 37);

/**
 * @generated from message lvdr.v2.document.DeleteScopeRequest
 */
export type DeleteScopeRequest = Message<"lvdr.v2.document.DeleteScopeRequest"> & {
  /**
   * @generated from field: string scope_id = 1;
   */
  scopeId: string;
};

/**
 * Describes the message lvdr.v2.document.DeleteScopeRequest.
 * Use `create(DeleteScopeRequestSchema)` to create a new message.
 */
export const DeleteScopeRequestSchema: GenMessage<DeleteScopeRequest> = /*@__PURE__*/
  messageDesc(file_document_document, 38);

/**
 * @generated from message lvdr.v2.document.ListScopesRequest
 */
export type ListScopesRequest = Message<"lvdr.v2.document.ListScopesRequest"> & {
};

/**
 * Describes the message lvdr.v2.document.ListScopesRequest.
 * Use `create(ListScopesRequestSchema)` to create a new message.
 */
export const ListScopesRequestSchema: GenMessage<ListScopesRequest> = /*@__PURE__*/
  messageDesc(file_document_document, 39);

/**
 * @generated from message lvdr.v2.document.ScopeListResponse
 */
export type ScopeListResponse = Message<"lvdr.v2.document.ScopeListResponse"> & {
  /**
   * @generated from field: repeated lvdr.v2.document.Scope scopes = 1;
   */
  scopes: Scope[];
};

/**
 * Describes the message lvdr.v2.document.ScopeListResponse.
 * Use `create(ScopeListResponseSchema)` to create a new message.
 */
export const ScopeListResponseSchema: GenMessage<ScopeListResponse> = /*@__PURE__*/
  messageDesc(file_document_document, 40);

/**
 * @generated from message lvdr.v2.document.ScopeResponse
 */
export type ScopeResponse = Message<"lvdr.v2.document.ScopeResponse"> & {
  /**
   * @generated from field: lvdr.v2.document.Scope scope = 1;
   */
  scope?: Scope | undefined;
};

/**
 * Describes the message lvdr.v2.document.ScopeResponse.
 * Use `create(ScopeResponseSchema)` to create a new message.
 */
export const ScopeResponseSchema: GenMessage<ScopeResponse> = /*@__PURE__*/
  messageDesc(file_document_document, 41);

/**
 * @generated from message lvdr.v2.document.GetScopeTreeRequest
 */
export type GetScopeTreeRequest = Message<"lvdr.v2.document.GetScopeTreeRequest"> & {
  /**
   * @generated from field: string scope_id = 1;
   */
  scopeId: string;
};

/**
 * Describes the message lvdr.v2.document.GetScopeTreeRequest.
 * Use `create(GetScopeTreeRequestSchema)` to create a new message.
 */
export const GetScopeTreeRequestSchema: GenMessage<GetScopeTreeRequest> = /*@__PURE__*/
  messageDesc(file_document_document, 42);

/**
 * @generated from message lvdr.v2.document.GetScopeTreeResponse
 */
export type GetScopeTreeResponse = Message<"lvdr.v2.document.GetScopeTreeResponse"> & {
  /**
   * @generated from field: repeated lvdr.v2.document.Scope chain = 1;
   */
  chain: Scope[];

  /**
   * @generated from field: repeated string effective_tags = 2;
   */
  effectiveTags: string[];
};

/**
 * Describes the message lvdr.v2.document.GetScopeTreeResponse.
 * Use `create(GetScopeTreeResponseSchema)` to create a new message.
 */
export const GetScopeTreeResponseSchema: GenMessage<GetScopeTreeResponse> = /*@__PURE__*/
  messageDesc(file_document_document, 43);

/**
 * @generated from message lvdr.v2.document.AttachResearchScopeRequest
 */
export type AttachResearchScopeRequest = Message<"lvdr.v2.document.AttachResearchScopeRequest"> & {
  /**
   * @generated from field: string research_id = 1;
   */
  researchId: string;

  /**
   * @generated from field: string scope_id = 2;
   */
  scopeId: string;

  /**
   * @generated from field: int32 priority = 3;
   */
  priority: number;
};

/**
 * Describes the message lvdr.v2.document.AttachResearchScopeRequest.
 * Use `create(AttachResearchScopeRequestSchema)` to create a new message.
 */
export const AttachResearchScopeRequestSchema: GenMessage<AttachResearchScopeRequest> = /*@__PURE__*/
  messageDesc(file_document_document, 44);

/**
 * @generated from message lvdr.v2.document.DetachResearchScopeRequest
 */
export type DetachResearchScopeRequest = Message<"lvdr.v2.document.DetachResearchScopeRequest"> & {
  /**
   * @generated from field: string research_id = 1;
   */
  researchId: string;

  /**
   * @generated from field: string scope_id = 2;
   */
  scopeId: string;
};

/**
 * Describes the message lvdr.v2.document.DetachResearchScopeRequest.
 * Use `create(DetachResearchScopeRequestSchema)` to create a new message.
 */
export const DetachResearchScopeRequestSchema: GenMessage<DetachResearchScopeRequest> = /*@__PURE__*/
  messageDesc(file_document_document, 45);

/**
 * @generated from message lvdr.v2.document.ListResearchScopesRequest
 */
export type ListResearchScopesRequest = Message<"lvdr.v2.document.ListResearchScopesRequest"> & {
  /**
   * @generated from field: string research_id = 1;
   */
  researchId: string;
};

/**
 * Describes the message lvdr.v2.document.ListResearchScopesRequest.
 * Use `create(ListResearchScopesRequestSchema)` to create a new message.
 */
export const ListResearchScopesRequestSchema: GenMessage<ListResearchScopesRequest> = /*@__PURE__*/
  messageDesc(file_document_document, 46);

/**
 * @generated from message lvdr.v2.document.ResearchScopeAttachmentProto
 */
export type ResearchScopeAttachmentProto = Message<"lvdr.v2.document.ResearchScopeAttachmentProto"> & {
  /**
   * @generated from field: string scope_id = 1;
   */
  scopeId: string;

  /**
   * @generated from field: int32 priority = 2;
   */
  priority: number;
};

/**
 * Describes the message lvdr.v2.document.ResearchScopeAttachmentProto.
 * Use `create(ResearchScopeAttachmentProtoSchema)` to create a new message.
 */
export const ResearchScopeAttachmentProtoSchema: GenMessage<ResearchScopeAttachmentProto> = /*@__PURE__*/
  messageDesc(file_document_document, 47);

/**
 * @generated from message lvdr.v2.document.ResearchScopeListResponse
 */
export type ResearchScopeListResponse = Message<"lvdr.v2.document.ResearchScopeListResponse"> & {
  /**
   * @generated from field: repeated lvdr.v2.document.ResearchScopeAttachmentProto attachments = 1;
   */
  attachments: ResearchScopeAttachmentProto[];

  /**
   * @generated from field: int32 effective_document_count = 2;
   */
  effectiveDocumentCount: number;
};

/**
 * Describes the message lvdr.v2.document.ResearchScopeListResponse.
 * Use `create(ResearchScopeListResponseSchema)` to create a new message.
 */
export const ResearchScopeListResponseSchema: GenMessage<ResearchScopeListResponse> = /*@__PURE__*/
  messageDesc(file_document_document, 48);

/**
 * @generated from message lvdr.v2.document.ReorderResearchScopesRequest
 */
export type ReorderResearchScopesRequest = Message<"lvdr.v2.document.ReorderResearchScopesRequest"> & {
  /**
   * @generated from field: string research_id = 1;
   */
  researchId: string;

  /**
   * @generated from field: repeated lvdr.v2.document.ResearchScopeAttachmentProto attachments = 2;
   */
  attachments: ResearchScopeAttachmentProto[];
};

/**
 * Describes the message lvdr.v2.document.ReorderResearchScopesRequest.
 * Use `create(ReorderResearchScopesRequestSchema)` to create a new message.
 */
export const ReorderResearchScopesRequestSchema: GenMessage<ReorderResearchScopesRequest> = /*@__PURE__*/
  messageDesc(file_document_document, 49);

/**
 * @generated from message lvdr.v2.document.ListTagVocabularyRequest
 */
export type ListTagVocabularyRequest = Message<"lvdr.v2.document.ListTagVocabularyRequest"> & {
};

/**
 * Describes the message lvdr.v2.document.ListTagVocabularyRequest.
 * Use `create(ListTagVocabularyRequestSchema)` to create a new message.
 */
export const ListTagVocabularyRequestSchema: GenMessage<ListTagVocabularyRequest> = /*@__PURE__*/
  messageDesc(file_document_document, 50);

/**
 * @generated from message lvdr.v2.document.ListTagVocabularyResponse
 */
export type ListTagVocabularyResponse = Message<"lvdr.v2.document.ListTagVocabularyResponse"> & {
  /**
   * @generated from field: repeated string tags = 1;
   */
  tags: string[];
};

/**
 * Describes the message lvdr.v2.document.ListTagVocabularyResponse.
 * Use `create(ListTagVocabularyResponseSchema)` to create a new message.
 */
export const ListTagVocabularyResponseSchema: GenMessage<ListTagVocabularyResponse> = /*@__PURE__*/
  messageDesc(file_document_document, 51);

/**
 * @generated from message lvdr.v2.document.SuggestTagsRequest
 */
export type SuggestTagsRequest = Message<"lvdr.v2.document.SuggestTagsRequest"> & {
  /**
   * @generated from field: string document_id = 1;
   */
  documentId: string;
};

/**
 * Describes the message lvdr.v2.document.SuggestTagsRequest.
 * Use `create(SuggestTagsRequestSchema)` to create a new message.
 */
export const SuggestTagsRequestSchema: GenMessage<SuggestTagsRequest> = /*@__PURE__*/
  messageDesc(file_document_document, 52);

/**
 * @generated from message lvdr.v2.document.SuggestTagsResponse
 */
export type SuggestTagsResponse = Message<"lvdr.v2.document.SuggestTagsResponse"> & {
  /**
   * @generated from field: repeated string suggested_tags = 1;
   */
  suggestedTags: string[];
};

/**
 * Describes the message lvdr.v2.document.SuggestTagsResponse.
 * Use `create(SuggestTagsResponseSchema)` to create a new message.
 */
export const SuggestTagsResponseSchema: GenMessage<SuggestTagsResponse> = /*@__PURE__*/
  messageDesc(file_document_document, 53);

/**
 * @generated from message lvdr.v2.document.UpdateDocumentTagsRequest
 */
export type UpdateDocumentTagsRequest = Message<"lvdr.v2.document.UpdateDocumentTagsRequest"> & {
  /**
   * @generated from field: string document_id = 1;
   */
  documentId: string;

  /**
   * @generated from field: repeated string tags = 2;
   */
  tags: string[];
};

/**
 * Describes the message lvdr.v2.document.UpdateDocumentTagsRequest.
 * Use `create(UpdateDocumentTagsRequestSchema)` to create a new message.
 */
export const UpdateDocumentTagsRequestSchema: GenMessage<UpdateDocumentTagsRequest> = /*@__PURE__*/
  messageDesc(file_document_document, 54);

/**
 * @generated from message lvdr.v2.document.RetryDocumentRequest
 */
export type RetryDocumentRequest = Message<"lvdr.v2.document.RetryDocumentRequest"> & {
  /**
   * @generated from field: string document_id = 1;
   */
  documentId: string;
};

/**
 * Describes the message lvdr.v2.document.RetryDocumentRequest.
 * Use `create(RetryDocumentRequestSchema)` to create a new message.
 */
export const RetryDocumentRequestSchema: GenMessage<RetryDocumentRequest> = /*@__PURE__*/
  messageDesc(file_document_document, 55);

/**
 * @generated from message lvdr.v2.document.SetConverterChoiceRequest
 */
export type SetConverterChoiceRequest = Message<"lvdr.v2.document.SetConverterChoiceRequest"> & {
  /**
   * @generated from field: string document_id = 1;
   */
  documentId: string;

  /**
   * "markitdown" | "docling"
   *
   * @generated from field: string choice = 2;
   */
  choice: string;

  /**
   * Optional per-document escalation-lane override ("" | "verify" | "full" |
   * "ocr"). Empty leaves the user's docling.vlm_mode setting in charge. Only
   * meaningful when choice == "docling". Tier-clamped + egress-guarded server-side.
   *
   * @generated from field: string docling_vlm_mode = 3;
   */
  doclingVlmMode: string;
};

/**
 * Describes the message lvdr.v2.document.SetConverterChoiceRequest.
 * Use `create(SetConverterChoiceRequestSchema)` to create a new message.
 */
export const SetConverterChoiceRequestSchema: GenMessage<SetConverterChoiceRequest> = /*@__PURE__*/
  messageDesc(file_document_document, 56);

/**
 * @generated from message lvdr.v2.document.SetConverterChoiceResponse
 */
export type SetConverterChoiceResponse = Message<"lvdr.v2.document.SetConverterChoiceResponse"> & {
  /**
   * @generated from field: string document_id = 1;
   */
  documentId: string;

  /**
   * @generated from field: string choice = 2;
   */
  choice: string;

  /**
   * "pending" or "convertingHiFi" after re-trigger
   *
   * @generated from field: string status = 3;
   */
  status: string;

  /**
   * echoes the stored per-doc lane override
   *
   * @generated from field: string docling_vlm_mode = 4;
   */
  doclingVlmMode: string;
};

/**
 * Describes the message lvdr.v2.document.SetConverterChoiceResponse.
 * Use `create(SetConverterChoiceResponseSchema)` to create a new message.
 */
export const SetConverterChoiceResponseSchema: GenMessage<SetConverterChoiceResponse> = /*@__PURE__*/
  messageDesc(file_document_document, 57);

/**
 * @generated from message lvdr.v2.document.RetryDoclingRequest
 */
export type RetryDoclingRequest = Message<"lvdr.v2.document.RetryDoclingRequest"> & {
  /**
   * @generated from field: string document_id = 1;
   */
  documentId: string;
};

/**
 * Describes the message lvdr.v2.document.RetryDoclingRequest.
 * Use `create(RetryDoclingRequestSchema)` to create a new message.
 */
export const RetryDoclingRequestSchema: GenMessage<RetryDoclingRequest> = /*@__PURE__*/
  messageDesc(file_document_document, 58);

/**
 * @generated from message lvdr.v2.document.RetryDoclingResponse
 */
export type RetryDoclingResponse = Message<"lvdr.v2.document.RetryDoclingResponse"> & {
  /**
   * @generated from field: string document_id = 1;
   */
  documentId: string;

  /**
   * "convertingHiFi" on success
   *
   * @generated from field: string status = 2;
   */
  status: string;

  /**
   * "RETRY_NOT_AVAILABLE" | "" (success)
   *
   * @generated from field: string error_code = 3;
   */
  errorCode: string;
};

/**
 * Describes the message lvdr.v2.document.RetryDoclingResponse.
 * Use `create(RetryDoclingResponseSchema)` to create a new message.
 */
export const RetryDoclingResponseSchema: GenMessage<RetryDoclingResponse> = /*@__PURE__*/
  messageDesc(file_document_document, 59);

/**
 * @generated from message lvdr.v2.document.ScopeToContextPreviewRequest
 */
export type ScopeToContextPreviewRequest = Message<"lvdr.v2.document.ScopeToContextPreviewRequest"> & {
  /**
   * @generated from field: string scope_id = 1;
   */
  scopeId: string;
};

/**
 * Describes the message lvdr.v2.document.ScopeToContextPreviewRequest.
 * Use `create(ScopeToContextPreviewRequestSchema)` to create a new message.
 */
export const ScopeToContextPreviewRequestSchema: GenMessage<ScopeToContextPreviewRequest> = /*@__PURE__*/
  messageDesc(file_document_document, 60);

/**
 * @generated from message lvdr.v2.document.ScopeToContextPreviewResponse
 */
export type ScopeToContextPreviewResponse = Message<"lvdr.v2.document.ScopeToContextPreviewResponse"> & {
  /**
   * @generated from field: string scope_id = 1;
   */
  scopeId: string;

  /**
   * @generated from field: string node_name = 2;
   */
  nodeName: string;

  /**
   * @generated from field: string parent_node_id = 3;
   */
  parentNodeId: string;

  /**
   * @generated from field: string parent_label = 4;
   */
  parentLabel: string;

  /**
   * @generated from field: int32 document_count = 5;
   */
  documentCount: number;

  /**
   * @generated from field: int32 note_count = 6;
   */
  noteCount: number;

  /**
   * @generated from field: string preview = 7;
   */
  preview: string;

  /**
   * @generated from field: bool too_many = 8;
   */
  tooMany: boolean;
};

/**
 * Describes the message lvdr.v2.document.ScopeToContextPreviewResponse.
 * Use `create(ScopeToContextPreviewResponseSchema)` to create a new message.
 */
export const ScopeToContextPreviewResponseSchema: GenMessage<ScopeToContextPreviewResponse> = /*@__PURE__*/
  messageDesc(file_document_document, 61);

/**
 * @generated from message lvdr.v2.document.ScopeToContextApplyRequest
 */
export type ScopeToContextApplyRequest = Message<"lvdr.v2.document.ScopeToContextApplyRequest"> & {
  /**
   * @generated from field: string scope_id = 1;
   */
  scopeId: string;

  /**
   * @generated from field: optional string trust_floor = 2;
   */
  trustFloor?: string | undefined;
};

/**
 * Describes the message lvdr.v2.document.ScopeToContextApplyRequest.
 * Use `create(ScopeToContextApplyRequestSchema)` to create a new message.
 */
export const ScopeToContextApplyRequestSchema: GenMessage<ScopeToContextApplyRequest> = /*@__PURE__*/
  messageDesc(file_document_document, 62);

/**
 * @generated from message lvdr.v2.document.ScopeToContextApplyResponse
 */
export type ScopeToContextApplyResponse = Message<"lvdr.v2.document.ScopeToContextApplyResponse"> & {
  /**
   * @generated from field: string scope_id = 1;
   */
  scopeId: string;

  /**
   * @generated from field: string node_id = 2;
   */
  nodeId: string;

  /**
   * @generated from field: string batch_id = 3;
   */
  batchId: string;
};

/**
 * Describes the message lvdr.v2.document.ScopeToContextApplyResponse.
 * Use `create(ScopeToContextApplyResponseSchema)` to create a new message.
 */
export const ScopeToContextApplyResponseSchema: GenMessage<ScopeToContextApplyResponse> = /*@__PURE__*/
  messageDesc(file_document_document, 63);

